import { z } from 'zod';

export const VALIDATE_SCHEMA = z
  .object({
    password: z
      .string({ message: 'Заполните обязательное поле' })
      .min(8, { message: 'Пароль должен быть не менее 8 символов' })
      .max(64, { message: 'Пароль должен быть не более 64 символов' }),
    passwordConfirmation: z
      .string({ message: 'Заполните обязательное поле' })
      .min(8, { message: 'Пароль должен быть не менее 8 символов' })
      .max(64, { message: 'Пароль должен быть не более 64 символов' }),
  })
  .refine(data => data.password === data.passwordConfirmation, {
    message: 'Пароли не совпадают',
    path: ['passwordConfirmation'],
  });
